import { DateTime } from 'luxon';
import { DisregardAnnotationFormValues } from './disregardAnnotation.types';

export const DAYS_IN_YEAR = 365;

export const EMPTY_DISREGARD_ANNOTATION: DisregardAnnotationFormValues = {
  processIds: [],
  variableIds: [],
  startTime: DateTime.now(),
  endTime: DateTime.now().plus({ days: 1 }),
  archived: false,
  message: '',
};

export const DISREGARD_ANNOTATION_TYPE = 'Disregard Data';
export const DISREGARD_ANNOTATION_TYPE_ID = 'disregard-annotation-type-id';
